<template>
    <svg height="25" width="25">
        <circle
            cx="12.5"
            cy="12.5"
            r="10"
            stroke-width="5"
            class="fill-brand stroke-base"
            :class="{ pulse }"
            :fill="color"
            :stroke="strokeColor"
        />
    </svg>
</template>

<script setup>
import tailwind from '@/lib/tailwind'

const props = defineProps({
    color: {
        type: String,
        default: tailwind.theme.color.brand.base,
    },
    strokeColor: {
        type: String,
        default: tailwind.theme.color.dark.base,
    },
    pulse: {
        type: Boolean,
        default: false,
    },
})
</script>
